import style from "./Label.module.css";
interface LabelProps {
  text: React.ReactNode;
  required?: boolean;
}

const Label: React.FC<LabelProps> = ({ text, required }) => {
  return (
    <span className={style.label}>
      {text}
      {required && <span className={style.required}>*</span>}
    </span>
  );
};
export default Label;
